import React from 'react'
import './index.styl'


class Component extends React.Component {

  constructor(props) {
    super(props)
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.state = {
      visible: false
    }
  }

  show() {
    this.setState({
      visible: true
    })
  }

  hide(evt) {
    if (evt.target.className === "overlay") {
      this.setState({
        visible: false
      })
    }
  }

  render() {
    return (
      <div className={this.state.visible ? "overlay" : ""} onClick={(evt) => this.hide(evt)}>
        <div className="menu">
          <button className={(this.state.visible ? "visible " : "") + "show-menu"} onClick={this.show}><span>Filter</span></button>
          <div className={(this.state.visible ? "visible " : "") + this.props.alignment}>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }

}

export default Component



// WEBPACK FOOTER //
// ./components/Segments/menu.js